// pending....
import React, { useEffect, useState } from "react";
import moment from "moment";
import BreadCrumb from "src/Components/GlobalComponents/BreadCrumb";
import SearchFilterInput from "src/Components/GlobalComponents/SearchFilterInput";
import TableWrapper from "src/Components/GlobalComponents/TableWrapper";
import { IqueryParams } from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import editIcon from "src/assets/images/edit-icon.png";
import deleteIcon from "src/assets/images/delete-icon.png";
import emtyImg from "src/assets/images/emty-img.png";
import ConfirmationModal from "src/Components/GlobalComponents/ConfirmationModal";
import UpsertPackage from "src/Components/AdminComponents/UpsertPackage";
import qs from "qs";
import { toast } from "react-toastify";
import httpRequest from "src/helpers/httpRequest";
import ToggleRadioBtn from "src/Components/ToggleRadioBtn";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { canWrite } from "src/helpers/helperFunctions";
import { CURRENCY } from "src/lib/constans";
interface IDiagnosticsPackages {
  _id: string;
  image: string;
  name: string;
  noOfTests: number;
  regularPrice: number;
  createdAt: string;
  status: boolean;
}

interface IPackageResponse {
  documents: IDiagnosticsPackages[];
  paginated: IPaginated;
}

const DiagnosticPackages: React.FC = () => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const hasWriteAccess = canWrite(userDetails, "diagnosticTest", false);
  const [isUpsert, setIsUpsert] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<string | null>(null);

  const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string>("");

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [allPakcages, setallPakcages] = useState<IDiagnosticsPackages[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    search: "",
    bool: false,
  });

  // Function to handle page change in pagination
  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };

  const handleChangeText = (txt: string) => {
    setQueryParams((prev) => ({
      ...prev,
      page: 1,
      // searchProduct: txt
      search: txt,
    }));
  };

  const deleteModalClose = () => {
    setDeleteModal(false);
    setDeleteId("");
  };

  const handleUpdateList = () => {
    setQueryParams((prev) => ({
      ...prev,
      bool: !prev.bool,
    }));
    setIsUpsert(false);
    setIsEdit(null);
  };

  const handleEdit = (id: string) => {
    if (!hasWriteAccess) {
      return;
    }
    setIsUpsert(true);
    setIsEdit(id);
  };

  const handleDelete = (id: string) => {
    if (!hasWriteAccess) {
      return;
    }
    setDeleteModal(true);
    setDeleteId(id);
  };

  const deleteRequests = async () => {
    setDeleteLoader(true);
    const { res, err } = await httpRequest<{ message: string }>({
      method: "delete",
      path: `/diagnostic-package/delete/${deleteId}`,
      params: {},
    });
    if (res) {
      toast(res?.message || "Success!", { type: "success" });
      setQueryParams((prev) => ({
        ...prev,
        bool: !prev.bool,
        page:
          allPakcages?.length > 1
            ? prev?.page
            : prev?.page > 1
            ? prev?.page - 1
            : prev?.page,
      }));
      deleteModalClose();
    } else {
      toast(err, { type: "error" });
    }
    setDeleteLoader(false);
  };

  const [statusLoader, setStatusLoader] = useState<string | null>(null);
  const handleStatusToogle = async (id: string) => {
    setStatusLoader(id);
    const { res, err } = await httpRequest<{
      message: string;
      status: boolean;
    }>({
      method: "put",
      path: `/diagnostic-package/update-status/${id}`,
      params: {},
    });
    if (res) {
      const { message = "", status = false } = res;
      toast(message, { type: "success" });
      setallPakcages((prev) =>
        prev.map((v) => (v?._id === id ? { ...v, status: status } : v))
      );
    } else {
      toast(err, { type: "error" });
    }
    setStatusLoader(null);
  };

  const fetchAllPackages = async () => {
    setIsLoader(true);
    const { bool, ...remainingParams } = queryParams;
    const { res, err } = await httpRequest<IPackageResponse>({
      path: `/diagnostic-package/all?${qs.stringify(remainingParams)}`,
    });
    if (res) {
      const { documents = [], paginated = { currentPage: 1, totalPages: 1 } } =
        res;
      setallPakcages(documents);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetchAllPackages();
  }, [queryParams]);

  return (
    <>
      <ConfirmationModal
        show={deleteModal}
        onClose={deleteModalClose}
        title="Are you sure you want to delete?"
        leftBtnText="No"
        rightBtnText="Yes"
        onConfirm={deleteRequests}
        loader={deleteLoader}
      />
      <BreadCrumb
        current="Packages"
        previous="dashboard"
        navigateUrl="/admin"
        btnText={"Add Package"}
        btnShow={true}
        onPress={() => {
          if (!hasWriteAccess) {
            return;
          }
          setIsUpsert((prev) => {
            if (prev) {
              setIsEdit(null);
            }
            return !prev;
          });
        }}
        isUpsert={isUpsert}
        btnClassName={`${!hasWriteAccess ? "cursor-not-allowed" : ""}`}
        BtnId="add-package-btn"
      />
      <div className="table-container">
        {isUpsert ? (
          <UpsertPackage onSuccess={handleUpdateList} isEdit={isEdit} />
        ) : (
          <>
            <SearchFilterInput
              onChangeText={handleChangeText}
              searchId="search-input"
            />
            <TableWrapper
              isLoading={isLoader}
              thead={[
                "Image",
                "Package Name",
                "Number of Tests",
                "Price",
                "Date",
                "Status",
                "Action",
              ]}
              page={paginated?.currentPage || 1}
              total={paginated?.totalPages || 0}
              columnWidth="10% 20% 20% 15% 15% 10% 10%"
              onChange={handlePageChange}
            >
              <div className="tbody-content-height">
                {allPakcages.map((item, index: number) => (
                  <ul
                    key={index}
                    className="font-size-16px tbody-light-table font-Poppins-Regular grid"
                    style={{
                      gridTemplateColumns: "10% 20% 20% 15% 15% 10% 10%",
                    }}
                  >
                    <li
                      className="action-last-colum-img"
                      style={{ justifyContent: "center", paddingLeft: 0 }}
                    >
                      <img
                        src={`${item?.image}`}
                        alt="category"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement; // Type assertion
                          target.src = emtyImg; // Handle error by setting default image
                        }}
                      />
                    </li>
                    <li>{item?.name || ""}</li>
                    <li>{item?.noOfTests || 0}</li>
                    <li>{`${CURRENCY} ${item?.regularPrice || 0}`}</li>
                    <li>{moment(item?.createdAt).format("DD-MM-YYYY")}</li>
                    <li
                      className="justify-center"
                      style={{ justifyContent: "center", paddingLeft: 0 }}
                    >
                      <ToggleRadioBtn
                        isToggled={item?.status}
                        handleToggle={() => handleStatusToogle(item._id)}
                        loader={statusLoader === item?._id ? true : false}
                        id={`status-toggle-${index + 1}`}
                        disabled={!hasWriteAccess}
                      />
                    </li>
                    <li className="action-last-colum">
                      <img
                        onClick={() => handleEdit(item?._id)}
                        src={editIcon}
                        alt="edit"
                        className={`${!hasWriteAccess ? "read_access" : ""}`}
                        id={`edit-${index + 1}`}
                      />
                      <img
                        onClick={() => handleDelete(item?._id)}
                        src={deleteIcon}
                        alt="delete"
                        className={`${!hasWriteAccess ? "read_access" : ""}`}
                        id={`delete-${index + 1}`}
                      />
                    </li>
                  </ul>
                ))}
              </div>
            </TableWrapper>
          </>
        )}
      </div>
    </>
  );
};

export default DiagnosticPackages;
